
import TitlePages from '../components/TitlePages'
import ProductsAll from '../components/Products/ProductsAll'
import Cardinfo from '../components/CardInfo'
export default {
  components: {
    ProductsAll,
    Cardinfo,
    TitlePages
  },
  data () {
    return {
      data: {
        title: 'Products',
        subTitle: 'Our Products',
        info: 'Our products are graded to the Advance’s stringent A+ standard. Coupled with our ISO9000 certification, we believe that our products will be able to exceed your expectations.',
        color: '#083B2F',
        size: '200',
        img: 'product-info'
      },
      selected: false
    }
  }
}
